import { useLayoutEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { navigateToSection } from '../../utils/helpers';

import { IconArrowBigRightLines } from '@tabler/icons-react';

const Home = () => {

	const carouselRef = useRef(null);
	const carouselInstance = useRef(null);
	const navigate = useNavigate();
	const location = useLocation();

	useLayoutEffect(() => {
		if (window.bootstrap && carouselRef.current) {
			carouselInstance.current = window.bootstrap.Carousel.getOrCreateInstance(carouselRef.current);
			carouselInstance.current.cycle();
		}
	}, []);

	const handleMouseEnter = () => {
		carouselInstance.current?.pause();
	};

	const handleMouseLeave = () => {
		carouselInstance.current?.cycle();
	};

	const carouselItems = [
		{
			id: 1,
			brand: 'BMW',
			title: 'Performanta si Eleganta',
			subtitle: 'Piese BMW',
			image: 'images/carousel-bmw.webp',
			background: 'images/wallpaper-1.webp',
			active: true
		},
		{
			id: 2,
			brand: 'Skoda',
			title: 'Calitate si Accesibilitate',
			subtitle: 'Piese Skoda',
			image: 'images/carousel-skoda.webp',
			background: 'images/wallpaper-4.webp'
		},
		{
			id: 3,
			brand: 'Volkswagen',
			title: 'Accesibilitate si Fiabilitate',
			subtitle: 'Piese Volkswagen',
			image: 'images/carousel-vw.webp',
			background: 'images/wallpaper-5.webp'
		},
		{
			id: 4,
			brand: 'Mercedes',
			title: 'Lux si Performanta',
			subtitle: 'Piese Mercedes',
			image: 'images/carousel-mercedes.webp',
			background: 'images/wallpaper-3.webp'
		}
	];

  	return (
		<div className="container-fluid home p-0" id="home">
			<div id="header-carousel" className="carousel slide" data-bs-ride="carousel" data-bs-pause="false" data-bs-interval="5000" ref={carouselRef}>
				<div className="carousel-inner"> 

					<div className="carousel-item active" style={{backgroundImage: `url(${carouselItems[0].background})`}}>
						<div className="carousel-caption d-flex align-items-center">
							<div className="container">
								<div className="row align-items-center justify-content-center justify-content-lg-start">

									<div className="col-10 col-lg-7 text-center text-lg-start heading" data-aos-offset="200" data-aos="fade-down">
										<h6 className="text-white text-uppercase mb-3"> {carouselItems[0].brand} </h6>
										<h1 className="display-5 text-white mb-4 pb-3"> {carouselItems[0].title} </h1>
										<h2 className="display-6 text-white mb-4 pb-3"> {carouselItems[0].subtitle} </h2>

										<button className="btn effect" onClick={() => navigateToSection('request', navigate, location)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
											<span className="ms-2" >Cere Oferta</span>
											<IconArrowBigRightLines className="ms-2" stroke={2} size={25}/>
										</button>
									</div>

									<div className="col-lg-5 d-none d-lg-flex position-relative" data-aos-offset="200" data-aos="zoom-in">
										<img className="img-fluid" src={carouselItems[0].image} alt={carouselItems[0].brand} />
										<img src="images/car-light.webp" alt="Car Light" className="vehicle-lights" />
									</div>
								</div>
							</div>
						</div>
					</div> 

					{carouselItems.slice(1).map((item) => (
						<div key={item.id} className="carousel-item" style={{backgroundImage: `url(${item.background})`}} >
							<div className="carousel-caption d-flex align-items-center">
								<div className="container">
									<div className="row align-items-center justify-content-center justify-content-lg-start">

										<div className="col-10 col-lg-7 text-center text-lg-start heading" data-aos-offset="200" data-aos="fade-down">
											<h6 className="text-white text-uppercase mb-3"> {item.brand} </h6>
											<h1 className="display-5 text-white mb-4 pb-3"> {item.title} </h1>
											<h2 className="display-6 text-white mb-4 pb-3"> {item.subtitle} </h2>

										<button className="btn effect" onClick={() => navigateToSection('request', navigate, location)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
												<span className="ms-2" >Cere Oferta</span>
												<IconArrowBigRightLines className="ms-2" stroke={2} size={25}/>
											</button>
										</div>

										<div className="col-lg-5 d-none d-lg-flex position-relative" data-aos-offset="200" data-aos="zoom-in">
											<img className="img-fluid" src={item.image} alt={item.brand} />
											<img src="images/car-light.webp" alt="Car Light" className="vehicle-lights" />
										</div>
									</div>
								</div>
							</div>
						</div> 
					))}
				</div>
			</div>
		</div>
  	);
};

export default Home;